import { PriceRules } from '@gorampe/catalog-adapter';

export function computeInstallation(
  rampSqFt: number,
  widthIn: 36 | 48,
  tarifs: PriceRules['installationPerSqFt'],
): number {
  return rampSqFt * (widthIn === 48 ? tarifs.width48 : tarifs.width36);
}

export function computeUninstallation(
  rampSqFt: number,
  widthIn: 36 | 48,
  tarifs: PriceRules['uninstallationPerSqFt'],
): number {
  return rampSqFt * (widthIn === 48 ? tarifs.width48 : tarifs.width36);
}
